import { defineField, defineType } from 'sanity'

import getPageInfo, { seoGroup } from '../objects/pageInfo'

export default defineType({
  name: 'configurationAccessories',
  title: 'Configure / Accessories',
  type: 'document',
  fieldsets: [
    {
      name: 'legacy',
      title: 'Legacy Proof of Concept',
      options: {
        collapsible: true,
        collapsed: false,
      },
    },
  ],
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    seoGroup,
  ],
  fields: [
    defineField({
      name: 'enabled',
      title: 'Enable accessories configurator',
      type: 'boolean',
      initialValue: true,
      description:
        'Turning this off will hide this accessories configurator from users',
      group: 'content',
    }),
    defineField({
      name: 'name',
      title: 'Configuration Name',
      type: 'string',
      validation: (rule) => rule.required(),
      group: 'content',
    }),
    defineField({
      name: 'categories',
      title: 'Categories',
      type: 'array',
      of: [
        {
          type: 'reference',
          to: [{ type: 'accessoryCategory' }],
        },
      ],
      group: 'content',
    }),
    getPageInfo({ path: 'configurationAccessories', lockCanonical: true }),
  ],
  preview: {
    select: {
      title: 'name',
      enabled: 'enabled',
      categories: 'categories',
    },
    prepare({ title = 'New Configuration', enabled, categories }) {
      const categoryCount = categories?.length || 0
      const status = enabled === false ? '⚠️ Disabled' : enabled ? '✓ Enabled' : 'Not set'

      return {
        title,
        subtitle: `${categoryCount} ${categoryCount === 1 ? 'category' : 'categories'} • ${status}`,
      }
    },
  },
})
